<template>
  <div>
    <div class="header">
      <span class="title">{{ $t('transactions.title') }}</span>
      <div class="stats">
        <div class="stat gross">
          <label>
            {{ $t('transactions.gross') }}
            <small>{{ $t('transactions.ofDateRange') }}</small>
          </label>
          <div :class="{'loading':stats.loading}">
            <span>${{ toFixed(stats.gross) }}</span>
            <i class="fas fa-spinner fa-spin" ></i>
          </div>
        </div>

        <div class="stat credit">
          <label>{{ $t('transactions.creditUsed') }}</label>
          <div :class="{'loading':stats.loading}">
            <span>${{ toFixed(stats.credits) }}</span>
            <i class="fas fa-spinner fa-spin" ></i>
          </div>
        </div>

        <!-- <div class="stat prov-online">
          <label>{{ $t('transactions.onlineProv') }}</label>
          <div :class="{'loading':loading}">
            <span>54</span>
            <i class="fas fa-spinner fa-spin" ></i>
          </div>
        </div> -->
      </div>
      <div class="manager-link">
        <a class="button cta warning xsmall" href="#/code" target="_blank"><!-- :href="managerUrl" -->
          <i class="fas fa-chart-line"></i>
          <span>Backend Manager</span>
        </a>

        <a :class="{'button cta success xsmall':true, 'disabled':!isListEmpty || isLoading, 'showMobile':isMobile, 'hideDesktop':isDesktop}"
          @click="exportTrx">
          <i class="fas fa-file-export"></i>
          <span>{{ $t('transactions.filter.export') }}</span>
        </a>
      </div>
      <!-- <div class="new-rsvp-link">
        <a class="button cta success xsmall" @click="newRsvp">
          <i class="fas fa-plus"></i>
          <span>Create RSVP</span>
        </a>
      </div> -->
    </div>

    <div class="body" id="top">
      <transactions-filter ref="filter" :isMobile="isMobile"></transactions-filter>
      <transactions-list @scrollToTop="scrollToTop" :isMobile="isMobile"></transactions-list>
    </div>

    <refund-credit-modal></refund-credit-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import RefundCreditModal from './RefundCreditModal'
import TransactionsFilter from './Filters'
import TransactionsList from './List'

export default {
  name: 'transactions',
  components: { RefundCreditModal, TransactionsFilter, TransactionsList },
  data () {
    return {
      isMobile: false,
      isDesktop: false
    }
  },
  computed: {
    stats () { return this.$store.state.transactions.stats },
    filter () {return this.$store.state.transactions.filter },
    managerUrl () {
      return 'http://manager.opoli.com/rsvp/' + moment(this.filter.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD') +
        '/' + moment(this.filter.dateTo, 'MM/DD/YYYY').add(1, 'days').format('YYYY-MM-DD')
    },
    isLoading () { return this.$store.state.transactions.loading },
    isListEmpty () { return this.$store.state.transactions.list.length }
  },
  methods: {
    toFixed (value) { return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    scrollToTop () {
      let elmnt = document.getElementById('top')
      elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
    },
    newRsvp () { window.location.href = '#/reservation/new' },
    setScreenSize() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.isDesktop = false
        this.isMobile = true
      } else {
        this.isDesktop = true
        this.isMobile = false
      }
    },
    exportTrx() {
      this.$refs.filter.exportTrx()
    }
  },
  mounted () {
    this.setScreenSize()
  },
  created() {
    window.addEventListener("resize", this.setScreenSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.setScreenSize);
  }
}
</script>

<style lang="scss" scoped>
.showDesktop, .showMobile {
  display: inline-block;
}

.hideDesktop, .hideMobile {
  display: none;
}

.header{
  margin-left:50px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;

  .title{
    padding: 10px;
    font-size: 22px;
    font-weight: 600;
    text-transform: uppercase;
    line-height: 50px;
    color: #3F2975;
  }
}

.manager-link, .new-rsvp-link{
  float:right;
  padding: 7px 10px;
  margin-right: 30px;

  &.new-rsvp-link{ margin-right: 0; }
  a{ text-decoration: none; }
  i{ font-size: 16px; }
  span{
    display: inline-block;
    font-size: 14px;
    margin-left: 3px;
  }
}

.stats{
  float:right;
  margin-right: 20px;
  padding: 5px 0;

  .stat{
    border:1px solid #aaa;
    display: inline-block;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    box-shadow: 1px 1px 3px rgba(0,0,0, .2);

    label, div{
      float: left;
      padding: 8px;
      height: 100%;
      font-weight: 600;
    }
    label{
      font-size: 12px;
      vertical-align: middle;
      color: #fff;
      line-height: 20px;

      small{
        display: block;
        font-weight: 100;
        font-size: 11px;
        margin-top: 1px;
      }
    }
    div{
      background: #fff;
      border-left: 1px solid #ccc;
      font-size: 21px;
      line-height: 1;
      transition: all .5s ease;
      max-width: 200px;

      i{ display: none; }
      &.loading{
        span{ display: none;}
        i{ display: block;}
      }
    }
    &.gross{
      margin-right: 10px;
      border-color: #0baf58;
      label{ background: #26d97a; line-height: 1; }
      div{ color: #26d97a; }
    }
    &.credit{
      border-color: #1283a5;
      label{ background: #26b0d9; }
      div{ color: #26b0d9; }
    }
    &.prov-online{
      border-color: #333;
      label{ background: #555; }
      div{ color: #555; }
    }
  }
}

.body{ padding: 20px; }

@media only screen and (max-width: 430px) {
  .body {
    padding-bottom: 40px;
  }
  .header {
    margin-left: 0;
    height: auto;

    .title {
      margin-left: 50px;
    }

    .stats {
      float: none;
      margin: 0;
      text-align: center;
      .gross {
        margin-right: 0;
      }
    }

    .manager-link {
      float: none;
      margin: 0;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Transactions/index.vue